<template>
  <!--================ call to action  =================-->
  <section v-if="PageCallAction != ''" class="calltoaction">
    <img :src="$imgURL + PageCallAction[0].insInstitucionalImagens[0].itgUrlImagem" alt="" class="calltoaction-bg">
    <div class="calltoaction-overlay d-flex flex-column justify-content-center align-items-center text-center">
      <h2 class="calltoaction-titulo">{{ PageCallAction[0].itiNome }}</h2>
      <div class="button-group-area">
        <router-link :to="PageCallAction[0].itiLinkBtn1"
          class="genric-btn primary-border"><i class="fa fa-whatsapp"></i> {{ PageCallAction[0].itiTextoBtn1 }}</router-link>
      </div>
    </div>
  </section>
  <!--================ call to action  =================-->

</template>

<script>
import axios from 'axios';

export default {
  name: 'PageCallAction',
  data: () => ({
    PageCallAction: [],
    showModernizacaoMenu: false,
    return: {
      isMenuOpen: false
    }
  }),
  methods: {
    toggleModernizacaoMenu() {
      this.showModernizacaoMenu = !this.showModernizacaoMenu;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    }
  },
  created() {
    //aqui busca callaction
    axios.get('/Process/InsInstitucional/institucional/58/callaction/0/x')
      .then(response => {
        this.PageCallAction = response.data;
        //console.log('PageCallAction')
        //console.log(this.PageCallAction)
      })
      .catch(error => {
        console.error(error);
      });
  }
};
</script>